module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_04@3x-8e9660d5f537e40a8e3545fd672f96fa.webp";